import { render, staticRenderFns } from "./PurchaseOrdersList.vue?vue&type=template&id=d6e158f8"
import script from "./PurchaseOrdersList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrdersList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrdersList.vue?vue&type=style&index=0&id=d6e158f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports